<template>
    <div class="flex flex-col min-h-screen bg-gray-50">
        <img :src="asset('img/welcome-bg.jpg')" class="absolute inset-0 object-cover object-center w-full h-full" />

        <div class="absolute top-0 left-0 z-10 w-full px-4 py-6 mx-auto sm:px-6">
            <Link href="/">
                <app-logo></app-logo>
            </Link>
        </div>

        <div class="flex-1 flex items-center justify-center py-[88px] z-10 container">
            <slot />
        </div>
    </div>
</template>

<script>
import AppLogo from '@Components/ApplicationLogo'
import { Link } from '@inertiajs/inertia-vue3'

export default {
    components: {
        AppLogo,
        Link
    },
    props: {

    }
}
</script>
